var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlights = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m20.924 27.669-4.935-9.397-4.913 4.913.45 3.154-1.33 1.33-2.252-4.012-3.99-2.232 1.33-1.33 3.11.408 4.913-4.913-9.354-4.892 1.76-1.76 11.606 2.64 4.914-4.913a1.82 1.82 0 0 1 1.33-.558q.772 0 1.351.58.58.578.569 1.34a1.84 1.84 0 0 1-.569 1.32l-4.913 4.913 2.682 11.65-1.76 1.759z"
})));
export default SvgFlights;